import { GetterTree } from 'vuex';
import { IAuthenticationState } from '@/modules/login/modules/AuthenticationPage/store/authentication.types';

const getters: GetterTree<IAuthenticationState, any> = {
  authError(state): string {
    return state.authError || '';
  },
};

export default getters;
